import React from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { Tabs } from '../../components/ui/Tabs';
import { Table } from '../../components/ui/Table';
import { ArrowLeft, Download, FileText, AlertTriangle } from 'lucide-react';
import { programs } from '../../data/mockData';
interface ProgramDetailProps {
  id: string;
  onBack: () => void;
}
export function ProgramDetail({
  id,
  onBack
}: ProgramDetailProps) {
  const program = programs.find(p => p.id === id) || programs[0];
  const renderOverview = () => <div className="space-y-6" data-id="element-618">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6" data-id="element-619">
        <Card title="Total Kuota" className="border-l-4 border-l-bulog-blue" data-id="element-620">
          <div className="text-3xl lg:text-4xl font-bold text-gray-900" data-id="element-621">
            {(program.quota / 1000).toLocaleString()}{' '}
            <span className="text-sm font-normal text-gray-500" data-id="element-622">Ton</span>
          </div>
          <div className="mt-2 text-sm text-gray-500" data-id="element-623">Target Nasional</div>
        </Card>
        <Card title="Realisasi" className="border-l-4 border-l-green-500" data-id="element-624">
          <div className="text-3xl lg:text-4xl font-bold text-green-600" data-id="element-625">
            {(program.realization / 1000).toLocaleString()}{' '}
            <span className="text-sm font-normal text-gray-500" data-id="element-626">Ton</span>
          </div>
          <div className="mt-2 text-sm text-gray-500" data-id="element-627">
            {Math.round(program.realization / program.quota * 100)}% dari
            target
          </div>
        </Card>
        <Card title="Sisa Kuota" className="border-l-4 border-l-bulog-orange" data-id="element-628">
          <div className="text-3xl lg:text-4xl font-bold text-bulog-orange" data-id="element-629">
            {((program.quota - program.realization) / 1000).toLocaleString()}{' '}
            <span className="text-sm font-normal text-gray-500" data-id="element-630">Ton</span>
          </div>
          <div className="mt-2 text-sm text-gray-500" data-id="element-631">
            Tersedia untuk alokasi
          </div>
        </Card>
      </div>

      <Card title="Dokumen Dasar" data-id="element-632">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 p-4 bg-gray-50 rounded-lg border border-gray-200" data-id="element-633">
          <div className="flex items-center gap-3 min-w-0 flex-1" data-id="element-634">
            <FileText className="text-red-500 flex-shrink-0" size={24} data-id="element-635" />
            <div className="min-w-0" data-id="element-636">
              <p className="font-semibold text-gray-900 truncate" data-id="element-637">
                Surat Penugasan SPHP 2025.pdf
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-638">
                Diupload 20 Jan 2025 oleh Admin Pusat
              </p>
            </div>
          </div>
          <Button size="sm" variant="outline" icon={<Download size={14} data-id="element-640" />} className="w-full sm:w-auto" data-id="element-639">
            Download
          </Button>
        </div>
      </Card>
    </div>;
  const renderAllocation = () => <Card data-id="element-641">
      <Table columns={[{
      header: 'Wilayah',
      accessor: 'region'
    }, {
      header: 'Gudang',
      accessor: 'warehouse',
      className: 'hidden md:table-cell'
    }, {
      header: 'Alokasi (Ton)',
      accessor: (item: any) => <span className="font-semibold" data-id="element-643">
                {item.allocation.toLocaleString()}
              </span>
    }, {
      header: 'Tersalur (Ton)',
      accessor: (item: any) => <span className="font-semibold" data-id="element-644">
                {item.dispatched.toLocaleString()}
              </span>,
      className: 'hidden lg:table-cell'
    }, {
      header: 'Status',
      accessor: (item: any) => <Badge variant={item.status === 'Full' ? 'success' : 'warning'} data-id="element-645">
                {item.status}
              </Badge>
    }]} data={[{
      region: 'DKI Jakarta',
      warehouse: 'Gudang Kelapa Gading',
      allocation: 50000,
      dispatched: 45000,
      status: 'Active'
    }, {
      region: 'Jawa Barat',
      warehouse: 'Gudang Cibitung',
      allocation: 120000,
      dispatched: 98000,
      status: 'Active'
    }, {
      region: 'Jawa Timur',
      warehouse: 'Gudang Buduran',
      allocation: 115000,
      dispatched: 110000,
      status: 'Active'
    }]} keyExtractor={i => i.warehouse} data-id="element-642" />
    </Card>;
  const renderExceptions = () => <Card data-id="element-646">
      <div className="space-y-4" data-id="element-647">
        {[1, 2].map(i => <div key={i} className="flex flex-col sm:flex-row items-start gap-3 p-4 bg-red-50 border border-red-100 rounded-lg" data-id="element-648">
            <AlertTriangle className="text-red-600 mt-0.5 flex-shrink-0" size={20} data-id="element-649" />
            <div className="flex-1 min-w-0" data-id="element-650">
              <p className="text-sm font-semibold text-red-900 mb-1" data-id="element-651">
                Kualitas di bawah standar (Gudang Panaikang)
              </p>
              <p className="text-xs text-red-700 leading-relaxed" data-id="element-652">
                Ditemukan kadar air 15% pada batch pengiriman #DO-2025-089. Stok
                di-hold.
              </p>
            </div>
            <Button size="sm" variant="danger" className="w-full sm:w-auto flex-shrink-0" data-id="element-653">
              Review
            </Button>
          </div>)}
      </div>
    </Card>;
  const tabs = [{
    id: 'overview',
    label: 'Ringkasan',
    content: renderOverview()
  }, {
    id: 'allocation',
    label: 'Alokasi Gudang',
    content: renderAllocation()
  }, {
    id: 'exceptions',
    label: 'Peringatan & Isu',
    content: renderExceptions()
  }, {
    id: 'audit',
    label: 'Audit Trail',
    content: <div className="p-8 text-center text-gray-500" data-id="element-654">
          Riwayat perubahan program akan muncul di sini.
        </div>
  }];
  return <div className="space-y-6" data-id="element-655">
      <div className="flex flex-col lg:flex-row items-start lg:items-center gap-4" data-id="element-656">
        <Button variant="ghost" onClick={onBack} icon={<ArrowLeft size={20} data-id="element-658" />} data-id="element-657">
          Kembali
        </Button>
        <div className="flex-1 min-w-0" data-id="element-659">
          <h1 className="text-2xl font-bold text-gray-900 truncate" data-id="element-660">
            {program.name}
          </h1>
          <div className="flex flex-wrap items-center gap-2 mt-2" data-id="element-661">
            <Badge variant="success" data-id="element-662">{program.status}</Badge>
            <span className="text-sm text-gray-500" data-id="element-663">• {program.period}</span>
            <span className="text-sm text-gray-500" data-id="element-664">• PIC: {program.pic}</span>
          </div>
        </div>
        <div className="flex flex-wrap gap-2 w-full lg:w-auto" data-id="element-665">
          <Button variant="outline" className="flex-1 sm:flex-none" data-id="element-666">
            Edit Program
          </Button>
          <Button className="flex-1 sm:flex-none" data-id="element-667">Download Laporan</Button>
        </div>
      </div>

      <Tabs tabs={tabs} data-id="element-668" />
    </div>;
}